<template>
  <div v-if="show">
    <transition name="fade">
      <div class="popup">
        <div @click="closeParentPopup()" class="offclick"></div>
        <div class="holder">
          <p @click="closeParentPopup()" class="close">x</p>
          <h3>{{ title }}</h3>
          <slot></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import firebase from "firebase";
import Swal from "sweetalert2";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
var moment = require("moment");

export default {
  name: "Popup",
  props: ["title", "show"],
  data() {
    return {};
  },
  created() {},
  methods: {
    closeParentPopup() {
      Swal.fire({
        title: "Are you sure?",
        text:
          "Closing this popup will remove all your information before saving",
        type: "info",
        showCancelButton: true,
        confirmButtonText: "YES",
        cancelButtonText: "CANCEL"
      }).then(result => {
        if (result.value) {
          this.$parent.closePopup();
        }
      });
    }
  }
};
</script>

<style lang="scss">
.popup {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.7);

  .offclick {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    height: 100%;
    width: 100%;
  }

  .holder {
    height: 100vh;
    overflow-y: scroll;
    background: #f7f7f7;
    position: relative;
    z-index: 2;
    padding: 30px;
    width: 100%;
    max-width: 700px;

    .close {
      position: absolute;
      font-size: 25px;
      margin: 0;
      padding: 10px 15px;
      top: 0;
      right: 0;
      opacity: 0.5;
      cursor: pointer;
    }

    h3 {
      font-size: 22px;
      margin-top: 0;
      margin-right: 50px;
      border-bottom: 3px solid #eaeaea;
      padding-bottom: 7px;
      margin-bottom: 30px;
    }

    .left {
      width: 200px;
      margin-right: 50px;
      flex: none;
      .input {
        width: 100%;
      }
    }

    .inputs {
      height: 100%;
      overflow: hidden;
      overflow-y: auto;
      &::-webkit-scrollbar {
        display: none;
      }
      .input {
        margin-bottom: 10px;
        &.checkbox {
          input[type="checkbox"] {
            width: 20px !important;
            height: 20px !important;
          }
          flex-direction: row;
          align-items: center;
          span {
            margin-left: 15px;
            opacity: 0.7;
          }
        }
      }
    }

    .right {
      width: 100%;

      .input {
        width: 100%;
        margin-bottom: 15px;

        textarea {
          resize: none;
        }
      }
    }

    .settings {
      display: flex;
      position: absolute;
      right: 20px;
      top: 20px;
      img {
        height: 23px;
        margin-left: 10px;
        cursor: pointer;
      }
    }

    .btns {
      display: flex;
      align-items: center;
      padding-top: 15px;
      justify-content: flex-start;
      bottom: 30px;
      left: 30px;

      .btn {
        margin-left: 20px;
      }
    }
  }
}

label {
  opacity: 0.7;
}
.hide_upload {
  display: none !important;
}
</style>
